import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {CartDecoratorErrorHandlingService} from '@app/checkout/services/cart-decorator-error-handling.service';
import {APP_CONFIG} from '@app/config/AppConfig';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {AddToCartEventService} from '@app/services/analytics/EDDL/events/checkout/add-to-cart-event.service';
import {CampaignTrackingService} from '@app/services/campaign-tracking.service';
import {CountrySelectorService} from '@app/services/country-selector.service';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';
import {getConfiguratorProviders} from '@dcp/configurator';
import {TodayAttributeValueHandler} from './services/handlers/today-attribute-value-handler';
import {PRODUCT_SEARCH_FIELDS, VARIANT_PRODUCT_SEARCH_FIELDS} from '@app/config/ProductSearchFieldsConfig';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';

/**
 * The following list contains all services and values as providers.
 * These providers are needed to provide the service instances and
 * configuration values to the library itself to make it work.
 */
export const configuratorProviderList = getConfiguratorProviders({
  services: {
    ACTIVE_CART_SERVICE_PROVIDER: DcpActiveCartService,
    ATTRIBUTE_VALUE_HANDLER: TodayAttributeValueHandler,
    AUTH_SERVICE_PROVIDER: DcpAuthService,
    CART_DECORATOR_ERROR_HANDLING_SERVICE_PROVIDER: CartDecoratorErrorHandlingService,
    CONFIG_SERVICE_PROVIDER: DcpConfigService,
    COUNTRY_SELECTOR_SERVICE_PROVIDER: CountrySelectorService,
    DEFAULT_MODAL_SERVICE_PROVIDER: DefaultModalService,
    TRANSACTION_TYPE_SERVICE_PROVIDER: TransactionTypeService,
  },
  values: {
    APP_CONFIG: APP_CONFIG,
    FEATURE_TOGGLES: UNLEASH_TOGGLES,
    PRODUCT_SEARCH_FIELDS_CONFIG: PRODUCT_SEARCH_FIELDS,
    VARIANT_PRODUCT_SEARCH_FIELDS_CONFIG: VARIANT_PRODUCT_SEARCH_FIELDS
  },
  optionalServices: {
    ADD_TO_CART_EVENT_SERVICE_PROVIDER: AddToCartEventService,
    CAMPAIGN_TRACKING_SERVICE_PROVIDER: CampaignTrackingService,
    SUPPORT_FORM_SERVICE_PROVIDER: DcpSupportFormService,
  },
});
